import { Button } from "@omni/ui/components/Button/button.component";
import { isDefined } from "@omni/utils/helper.utils";
import { cn } from "@omni/utils/styles";

import { Anchor } from "@/components/General/Anchor/anchor.component";
import { useCashbackContext } from "@/components/Product/ECommerce/components/pricing/components/cashback/context/cashback.context";
import { ModalType } from "@/redux/modules/value/modal/modal.types";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import { useModalRouter } from "@/utils/hooks/useModalRouter";

export const Information = () => {
    const { t } = useGranite();

    const { redirectPath } = useCashbackContext();

    const { open: openCashbackModal } = useModalRouter(ModalType.Cashback);

    const handleOnCashbackInformationClick = () => {
        openCashbackModal();
    };

    return (
        <p>
            {isDefined(redirectPath) && (
                <Anchor
                    color={"link"}
                    className={cn("tw:p-0 tw:text-sm!")}
                    href={redirectPath}
                >
                    {t("ecommerce.label.here")}
                </Anchor>
            )}
            {!isDefined(redirectPath) && (
                <Button
                    color={"link"}
                    className={cn("tw:p-0 tw:text-sm!")}
                    onClick={handleOnCashbackInformationClick}
                >
                    {t("ecommerce.label.here")}
                </Button>
            )}
            {t("ecommerce.label.cashbackInformation", "")}
        </p>
    );
};
